// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3qQDw","noInteraction":"EventWrapper_noInteraction__1DvCj"};